import { ApiUrlModel } from "../entities/chatApiUrl-model";
const saveMessage = "saveMessage";
const saveChatUser = "saveChatUser";
const getUserChatSummary = 'getUserChatSummary'
const summaryConversation = 'summaryConversation'
const markMsgRead='markMsgRead'
const getUserBasicInfoByUserId = 'getUserBasicInfoByUserId'
const getBookingListOfUser = 'getBookingListOfUser'
const getAllConsultationbyUserId="getAllConsultationbyUserId"
const getUsersDetail='getUsersDetail'
const checkUserIsOnline='checkUserIsOnline'
const getProjectsChatConsultant = 'getProjectsChatConsultant'
const getProjectsChatClient = 'getProjectsChatClient'
const pinChat = 'pinChat'
const unpinChat = 'unpinChat'
const blockReasons = 'blockReasons'
const blockUser = 'blockUser'
const unblockUser = 'unblockUser'
const blockStatus = 'blockStatus'
const virtco_gateway_path = process.env.REACT_APP_URL;
const ChatApiUrl = (url: string, param = new ApiUrlModel("")) => {
    switch (url) {
        case saveMessage: return `${virtco_gateway_path}/api/chat/SaveMessage`;
        case saveChatUser: return `${virtco_gateway_path}/api/chat/SaveUsers`;
        case getUserChatSummary: return `${virtco_gateway_path}/api/chat/GetUserChatSummary`;
        case summaryConversation: return `${virtco_gateway_path}/api/chat/Summary?RecipientId=${param.id}&RecipientType=${param.type}&PageNumber=${param.pageNo}&PageSize=${param.pageSize}&OrderBy=desc`;
        case markMsgRead:return `${virtco_gateway_path}/api/chat/MarkRead/${param.id}`;
        case getUserBasicInfoByUserId: return `${virtco_gateway_path}/api/Profile/GetProfileDetailByUserId/${param.id}`;
        case getBookingListOfUser: return `${virtco_gateway_path}/api/Booking/${param.id}`;
        case getAllConsultationbyUserId: return `${virtco_gateway_path}/api/Consultation/GetAll/${param.id}`;
        case getUsersDetail:return `${virtco_gateway_path}/api/Auth/GetUser/${param.id}`;
        case checkUserIsOnline:return `${virtco_gateway_path}/api/chat/GetUserIsOnline/${param.id}`;
        case getProjectsChatConsultant: return `${virtco_gateway_path}/api/v1/projects/dashboard/chat/consultant/${param.id}`;
        case getProjectsChatClient: return `${virtco_gateway_path}/api/v1/projects/dashboard/chat/client/${param.id}`;
        case pinChat: return `${virtco_gateway_path}/api/chat/Pin`;
        case unpinChat: return `${virtco_gateway_path}/api/chat/UnPin`;
        case blockReasons: return `${virtco_gateway_path}/api/chat/BlockReasons`;
        case blockUser: return `${virtco_gateway_path}/api/chat/Block`;
        case unblockUser: return `${virtco_gateway_path}/api/chat/UnBlock`;
        case blockStatus: return `${virtco_gateway_path}/api/chat/BlockStatus/${param.id}`;
    }
}
export default ChatApiUrl;